import React from 'react';
import { useStaticQuery } from 'gatsby';
import { SEO } from './SEO';
const HeadQuery = "1122327541";
export function Head(_ref) {
  let {
    title
  } = _ref;
  const data = useStaticQuery(HeadQuery);
  return /*#__PURE__*/React.createElement(SEO, {
    title: title ? title + " - " + data.site.siteMetadata.title : data.site.siteMetadata.title
  });
}